<div class="w-100 mb-4 pt-4">
  <p class="font-13">
    <strong>{{ 'attendance.leadSource.leadSourceTitle' | translate }}</strong>
  </p>

  <form [formGroup]="formGroup">
    <mat-select
      class="form-control"
      formControlName="name"
      [placeholder]="'attendance.leadSource.selectSource' | translate"
      [panelClass]="'custom-select-panel'"
      (selectionChange)="onSelectLeadSource($event)"
    >
      <div class="w-100 p-2 mb-2">
        <input
          class="form-control"
          type="text"
          [placeholder]="'attendance.leadSource.search' | translate"
        />
      </div>

      @for (item of leadSourceList; track item) {
        <mat-option [value]="item">{{ item?.name }}</mat-option>
      }
    </mat-select>
  </form>

  @if(!!contactLeadSource?.name) {
    <div class="d-block mt-1">
      <div class="d-flex align-items-center gap-2 justify-content-between p-2 border rounded">
        <p class="d-flex flex-column text-muted font-14 mb-0">
          {{ 'attendance.leadSource.sourceLabel' | translate }} <strong>{{ contactLeadSource?.name }}</strong>
        </p>
        <button class="button-delete" (click)="deleteLeadSource()">
          <i class="ri-delete-bin-5-line text-danger"></i>
        </button>
      </div>
    </div>
  }
</div>
